import { render, staticRenderFns } from "./consultation-list.vue?vue&type=template&id=677c26a4&"
import script from "./consultation-list.vue?vue&type=script&lang=js&"
export * from "./consultation-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports